<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
    <!-- modal town select -->
    <div id="menu-town-select" class="menu menu-box-modal rounded-m p-3" 
      data-menu-height="380" 
      data-menu-width="310">
      <h1 class="text-center font-700">Vyber mesto</h1>
      <div data-menu="menu-town-select" class="input-style has-borders input-style-always-active no-icon mb-4">
        <label for="form5" class="color-black-dark font-500">Filter</label>
        <input type="text" v-model="filterCity" class="form-control validate-text bg-white" id="form5">
        <span v-if="!filterCity"><i class="fa fa-search"></i></span>
        <div @click.stop.prevent="clearCity()" v-if="filterCity" class="font-10 pointer" style="position: absolute; top: 50%; right: 5px; margin-top: -12px; margin-right: 10px; opacity: .3;"><i class="fa fa-times"></i></div>
        <em></em>
      </div>
      <div style="overflow-x: none; overflow-y: scroll; max-height: 225px;">
        <div class="close-menu pointer clickable" v-for="city in filteredCityList" :key="city" @click.stop.prevent="$emit('update:modelValue', city)">
          <div class="divider mt-1 mb-1"></div>
          <div class="p-2">{{ city }}</div>
        </div>
      </div>
    </div>    
</template>

<script>
import { ref } from 'vue'
import storage from '@/lib/storage'

export default {
  name: 'SelectCityModal',
  setup() {
    const filterCity = ref('')
    const cityList = ref([])
    const filteredCityList = ref([])

    function filter (value) {
      filteredCityList.value = [];
      (cityList.value || []).forEach(city => {
        if ((city || '').toLowerCase().includes((value || '').toLowerCase()))
          filteredCityList.value.push(city)
      })
      filteredCityList.value.unshift('Všetky')
    }

    function clearCity () {
      filterCity.value = ''
    }

    function getCityList() {
      cityList.value = []
      storage.getAllCustomers()
        .then(data => {
          (data || []).forEach(item => {
            if (cityList.value.indexOf(item.town) === -1)
              cityList.value.push(item.town)
          })
        })
        .finally(() => {
          cityList.value.sort()
          filter(filterCity.value)
        })
    }

    return {
      filterCity,
      cityList,
      filteredCityList,
      filter,
      clearCity,
      getCityList
    }
  },
  created () {
    this.getCityList()
  },
  watch: {
    filterCity: function (value) {
      this.filter(value)
      setTimeout(() => {
        const menuClose = document.querySelectorAll('.close-menu, .menu-hider');
        menuClose.forEach(el => el.addEventListener('click',() =>{
          const activeMenu = document.querySelectorAll('.menu-active');
          for(let i=0; i < activeMenu.length; i++){activeMenu[i].classList.remove('menu-active');}
        }));
      })
    }
  }
}
</script>
